import PropTypes from 'prop-types';
import React from 'react';
import Loading from 'components/Loading';
import { Dialog, FontIcon } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import styles from './styles.scss';
import cx from 'classnames';
import { getMinLocalDate } from '../../../utils/dateUtils';

const theme = {
  RTDialog: styles,
};

const priceHeaderClasses = cx([styles.tableHeader, styles.priceColumn]);
const priceCellClasses = cx([styles.tableCell, styles.priceColumn]);

const PayRateHistory = (props) => {
  const { payRates = [] } = props;

  const rateHistoryRows = payRates.map(rate => (
    <tr key={rate.id}>
      <td className={styles.tableCell}>{rate.who}</td>
      <td className={styles.tableCell}>{getMinLocalDate(rate.created_at)}</td>
      <td className={priceCellClasses}>{rate.price}</td>
    </tr>
  ));

  const content = props.loading ? (<Loading />) : (
    <table className={styles.historyTable}>
      <thead>
        <tr>
          <th className={styles.tableHeader}>Name</th>
          <th className={styles.tableHeader}>Date Changed</th>
          <th className={priceHeaderClasses}>Price</th>
        </tr>
      </thead>
      <tbody>
        {rateHistoryRows}
      </tbody>
    </table>
  );
  return (
    <ThemeProvider theme={theme}>
      <Dialog active={props.showHistory} onEscKeyDown={props.closeHistory}>
        <FontIcon value="close" className={styles.closeIcon} onClick={props.closeHistory} />
        <div className={styles.rateName}>{props.rateName}</div>
        <div className={styles.tableContainer}>
          {content}
        </div>
      </Dialog>
    </ThemeProvider>
  );
};

PayRateHistory.propTypes = {
  showHistory: PropTypes.bool,
  closeHistory: PropTypes.func,
  rateName: PropTypes.string,
  loading: PropTypes.bool,
  payRates: PropTypes.array,
};

export default PayRateHistory;



// WEBPACK FOOTER //
// ./client/app/shared/components/PayRateHistory/index.jsx